import { useGetDrawDownRepaymentScheduleIwocapay } from '../../../../api/lending/lapiHooks';
import { displayCurrency } from '../../../../utils/DisplayCurrency';
import { normaliseDate } from '../../../Signup/stateNormalisation';
import { useCurrentPayLink } from '../../hooks/useCurrentPayLink';

export const RepaymentPlan = () => {
  const { drawDownRepaymentScheduleIwocapay: repaymentSchedule } =
    useGetDrawDownRepaymentScheduleIwocapay();
  const { payLink } = useCurrentPayLink();
  if (!repaymentSchedule?.summary || !repaymentSchedule.schedule) return null;

  const { schedule, summary } = repaymentSchedule;

  return (
    <>
      {payLink?.capture_delay_hours ? <h3>Your example payment plan</h3> : null}
      <table className="my-[20px] w-full table-fixed border-collapse overflow-hidden rounded-l border-none bg-white text-center font-reg text-secondary-20 outline outline-1 outline-secondary-80">
        <thead className="border-b border-secondary-80 bg-secondary-95 font-bold text-primary-10">
          <tr>
            <th className="p-s pl-s text-left m600:p-r m600:pl-l">
              {payLink?.capture_delay_hours ? 'Payment day' : 'Date'}
            </th>
            <th className="p-s m600:p-r">Invoice amount</th>
            <th className="p-s m600:p-r">Interest*</th>
            <th className="p-s pr-s text-right font-bold m600:p-r m600:pr-l">
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {schedule.map((repayment, index) => (
            <tr key={repayment.date}>
              <td className="py-[6px] pl-s text-left m600:pl-l">
                {payLink?.capture_delay_hours
                  ? `Day ${30 * (index + 1)}`
                  : normaliseDate(repayment.date)}
              </td>
              <td className="py-[6px]">
                {displayCurrency(repayment.principal)}
              </td>
              <td className="py-[6px] text-secondary-40">
                {displayCurrency(repayment.interest)}
              </td>
              <td className="py-[6px] pr-s text-right font-bold m600:pr-l">
                {displayCurrency(repayment.total)}
              </td>
            </tr>
          ))}
          <tr className="border-t border-secondary-80 bg-secondary-95 font-[200] text-primary-10">
            <td className="p-s pl-s text-left font-bold m600:p-r m600:pl-l">
              Total
            </td>
            <td className="p-s m600:p-r">
              {displayCurrency(summary.total_credit_amount!)}
            </td>
            <td className="p-s text-secondary-40 m600:p-r">
              {displayCurrency(summary.total_interest!)}
            </td>
            <td className="p-s pr-s text-right font-bold m600:p-r m600:pr-l">
              {displayCurrency(summary.total_payable!)}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
